export const convertPercentToNumber = value => {
	if (value.charAt(value.length-1) === '%') {
		return value.slice(0, -1);
	}
	return value;
}

export const setDateToISOString = date => {
    let dateTime = new Date(date);
    if (typeof(date) === 'object') {
      dateTime = date.toISOString().slice(0,-5);
    }
    return dateTime;
}

export const getAtmosphereReaction = (value) => {
    let src;
    if (value === "negative") {
        src = `${process.env.PUBLIC_URL}/dummy_icons/red-smiley.png`;
    } else if (value === "positive") {
        src = `${process.env.PUBLIC_URL}/dummy_icons/green-smiley.png`;
    } else if (value === "neutral") {
        src = `${process.env.PUBLIC_URL}/dummy_icons/green-smiley.png`;
    } else if (value === "red") {
        src = `${process.env.PUBLIC_URL}/dummy_icons/red-smiley.png`;
    } else if (value === "blue") {
        src = `${process.env.PUBLIC_URL}/dummy_icons/blue-smiley.png`;
    } else if (value === "green") {
        src = `${process.env.PUBLIC_URL}/dummy_icons/green-smiley.png`;
    }
    return src;
}

export const getAtmosphereChart = (value) => {
    let src;
    if (value === "negative") {
        src = `${process.env.PUBLIC_URL}/icons/negative-chart.svg`;
    } else if (value === "positive") {
        src = `${process.env.PUBLIC_URL}/icons/positive-chart.svg`;
    }
    return src;
}

export const getAtmosphereChat = (value) => {
    let src;
    if (value === "msg") {
        src = `${process.env.PUBLIC_URL}/dummy_icons/chat-msg-icon.png`;
    } else if (value === "call") {
        src = `${process.env.PUBLIC_URL}/dummy_icons/chat-call-icon.png`;
    }
    return src;
}

export const getDashboardIcon = (value) => {
    switch(value) {
        case 'overallSmiley':
            return `${process.env.PUBLIC_URL}/dummy_icons/overall-smiley-light.png`;
        case 'overallDark':
                return `${process.env.PUBLIC_URL}/dummy_icons/overall-dark.png`;
        case 'deliveryLight':
            return `${process.env.PUBLIC_URL}/dummy_icons/delivery-light.png`;
        case 'averageLight':
                return `${process.env.PUBLIC_URL}/dummy_icons/average-light.png`;
        case 'callLight':
                return `${process.env.PUBLIC_URL}/dummy_icons/call-light.png`;
        case 'msgLight':
                return `${process.env.PUBLIC_URL}/dummy_icons/msg-light.png`;
        case 'redSmiley':
                return `${process.env.PUBLIC_URL}/dummy_icons/red-smiley.png`;
        case 'greenSmiley':
                return `${process.env.PUBLIC_URL}/dummy_icons/green-smiley.png`;
        case 'blueSmiley':
                return `${process.env.PUBLIC_URL}/dummy_icons/blue-smiley.png`;
        default: 
            return;
    }
}

export const getRandomString = () => Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);



export function getInitialMode() {
    const isReturningUser = "theme" in localStorage;
    const savedMode = JSON.parse(localStorage.getItem("theme"));
    const userPrefersDark = getPrefColorScheme();

    if (isReturningUser) {
      return savedMode;
    } else if (userPrefersDark) {
      return true;
    } else {
      return false;
    }
  }

  function getPrefColorScheme(mode) {
    if (!window.matchMedia) return;
    
    return window.matchMedia("(prefers-color-scheme: theme)").matches;
  }

  export function duration(time) {
    const sec_num = parseInt(time, 10);
    const hours   = Math.floor(sec_num / 3600);
    const minutes = Math.floor((sec_num - (hours * 3600)) / 60);
    const seconds = sec_num - (hours * 3600) - (minutes * 60);
    if (hours   <= 0) {
        if (minutes <= 0) {
          return seconds+'s';
        } else if (seconds <= 0 && minutes > 0) {
            return minutes+'min';
        }
        return minutes+'min '+seconds+'s';
    } 
  
      return hours+'h '+minutes+'min '+seconds+'s';
  }

  export function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  const characters ='ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

export const generateRandomString = (length = 10) => {
    let result = ' ';
    const charactersLength = characters.length;
    for ( let i = 0; i < length; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }

    return result;
}